import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  subtitle?: string;
  headerActions?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ children, title, subtitle, headerActions }) => (
  <div className="bg-white dark:bg-gray-800 rounded text-slate-500 dark:text-slate-400 shadow-slate-200 dark:shadow-slate-700 m-4">
    {(title || subtitle || headerActions) && (
      <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
          <div className="hidden md:block">
            {title && (
              <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-100">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                {subtitle}
              </p>
            )}
          </div>
          {headerActions && (
            <div className="w-full sm:w-auto sm:ml-auto [&>div]:flex-wrap [&>div]:gap-2 sm:[&>div]:flex-nowrap [&>div]:space-x-0 sm:[&>div]:space-x-2 [&>div>button]:w-full sm:[&>div>button]:w-auto [&>div>.relative]:w-full sm:[&>div>.relative]:w-auto [&>div>.relative>button]:w-full">
              {headerActions}
            </div>
          )}
        </div>
      </div>
    )}
    <div className="p-6">
      <div>{children}</div>
    </div>
  </div>
);

export default Card;